import { render, staticRenderFns } from "./shoplist.vue?vue&type=template&id=32070438&scoped=true"
import script from "./shoplist.vue?vue&type=script&lang=js"
export * from "./shoplist.vue?vue&type=script&lang=js"
import style0 from "./shoplist.vue?vue&type=style&index=0&id=32070438&prod&lang=scss&scoped=true"
import style1 from "./shoplist.vue?vue&type=style&index=1&id=32070438&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32070438",
  null
  
)

export default component.exports